import script from "./VVVUsersNew.vue?vue&type=script&setup=true&lang=js"
export * from "./VVVUsersNew.vue?vue&type=script&setup=true&lang=js"

import "./VVVUsersNew.vue?vue&type=style&index=0&id=a3197b92&scoped=true&lang=css"
import "./VVVUsersNew.vue?vue&type=style&index=1&id=a3197b92&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3197b92"]])

export default __exports__